export enum BulkTimeOffImporterName {
    Requests = 'requests',
    Balances = 'balances',
    Adjustments = 'adjustments',
}
